import type { Editor, Storage } from "@tiptap/core";
import type { RefOrGetter } from "ls/common/types";
import type { ShortcutJs } from "@/generated/models";
import { Extension } from "@tiptap/core";
import { toValue } from "vue";

export interface ShortcutInformationStorage {
  file: () => ShortcutJs;
}
declare module "@tiptap/core" {
  interface Storage {
    shortcutInformation: ShortcutInformationStorage;
  }
}

function isShortcutStorage(storage: unknown): storage is ShortcutInformationStorage {
  return typeof storage === "object" && !!storage && "file" in storage && typeof storage.file === "function";
}

export const extensionName = "shortcutInformation";

export function useShortcutInformationExtension(file: RefOrGetter<ShortcutJs>) {
  const extension = Extension.create({
    name: extensionName,

    addStorage() {
      return {
        file: () => toValue(file),
      } satisfies ShortcutInformationStorage;
    },
  });

  return {
    extension,
  };
}

function getShortcutInformationFromStorage(storage: Storage) {
  const shortcutStorage = storage.shortcutInformation;
  if (!isShortcutStorage(shortcutStorage)) {
    throw new Error("Shortcut information is missing in storage.");
  }
  return shortcutStorage.file();
}

export function getShortcutInformation(editor: Editor) {
  return getShortcutInformationFromStorage(editor.storage);
}
